import styled from "styled-components/macro";
import { ContainerPopupMenu } from "../../Header/styles";

export const ProfileNavbarContainer = styled(ContainerPopupMenu)`
  padding-top: 3.25em;
  z-index: 30;

  & a {
    color: ${({ theme }) => theme.colors.text};
    padding: 0.5em 1em;
    &.active {
      font-weight: ${({ theme }) => theme.font.weightSemiMedium};
    }
    &:hover {
      color: ${({ theme }) => theme.colors.primary};
    }
  }
  & li {
    list-style-type: none;
    &:last-child a {
      padding-bottom: 1em;
    }
  }

  @media ${({ theme }) => theme.media.tablet} {
    right: 0;
    top: 0;
  }
  @media ${({ theme }) => theme.media.phone} {
    right: 0;
    top: 0;
  }
`;
